import React from "react"
import { connect } from "react-redux"
import Line from "../../core/Line"
import {
  ForwardIcon,
  Icon,
  PlusIcon,
  MarkerIcon,
  BankCardIcon
} from "../../core/icons"
import { BrowserRouter as Router, Route, Link } from "react-router-dom"
import {
  Slider,
  Select,
  Button,
  Col,
  Row,
  Popover,
  Icon as AIcon,
  Switch,
  Tooltip
} from "antd"
import styled from "styled-components"
import { getIntegrationIcon } from "./"

const SignUp = styled.div`
  opacity: 0.5;
  &:hover {
    opacity: 0.9;
  }

  a {
    font-size: 12px;
    color: rgb(36, 150, 197);
    text-decoration: underline;
  }
`

const All = ({
  integration_accounts,
  integrations_enabled,
  userTokenId,
  enableFreshbooks,
  disableFreshbooks,
  enableXero,
  disableXero
}) => (
  <div>
    <Row gutter={20} type="flex" align="middle">
      <Col sm={3}>
        <img
          style={{ maxWidth: 80, width: "100%" }}
          src={getIntegrationIcon("freshbooks")}
        />
      </Col>
      <Col sm={5}>
        <h3 style={{ margin: 0 }}>Freshbooks</h3>
      </Col>
      <Col sm={12} style={{ fontSize: 12 }}>
        Send your Everlance mileage and transactions totals to your Freshbooks
        account.
        <SignUp>
          No account?{" "}
          <a
            target="_blank"
            href="https://www.freshbooks.com/pages/everlance?ref=12908"
          >
            Sign up here and get 2 months free.
          </a>
        </SignUp>
      </Col>
      <Col sm={4}>
        {integrations_enabled && integrations_enabled.includes("freshbooks") ? (
          <a style={{ color: "red" }} onClick={disableFreshbooks}>
            Disable
          </a>
        ) : (
          <a onClick={enableFreshbooks}>Enable</a>
        )}
      </Col>
    </Row>
    <hr />
    <Row gutter={20} type="flex" align="middle">
      <Col sm={3}>
        <img
          style={{ maxWidth: 80, width: "100%" }}
          src={getIntegrationIcon("xero")}
        />
      </Col>
      <Col sm={5}>
        <h3 style={{ margin: 0 }}>Xero</h3>
      </Col>
      <Col sm={12} style={{ fontSize: 12 }}>
        Send your Everlance mileage and transactions totals to your Xero
        account.
        <SignUp>
          No account?{" "}
          <a href="https://www.xero.com/us/signup/accounting/">Sign up here.</a>
        </SignUp>
      </Col>
      <Col sm={4}>
        {integrations_enabled && integrations_enabled.includes("xero") ? (
          <a style={{ color: "red" }} onClick={disableXero}>
            Disable
          </a>
        ) : (
          <a onClick={enableXero}>Enable</a>
        )}
      </Col>
    </Row>
    <hr />
    <Row gutter={20} type="flex" align="middle">
      <Col sm={3}>
        <div
          style={{
            height: 80,
            width: 80,
            border: "solid 1px grey",
            borderRadius: 10,
            fontSize: 50,
            display: `flex`,
            justifyContent: "center",
            opacity: 0.5
          }}
        >
          ?
        </div>
      </Col>
      <Col sm={5}>
        <h3 style={{ margin: 0 }}>Other</h3>
      </Col>
      <Col sm={12} style={{ fontSize: 12 }}>
        Looking for an integration?
        <SignUp>
          <a target="_blank" href="https://goo.gl/forms/UfbksDaYNbw0cqcv2">
            {" "}
            Let us know!{" "}
          </a>
        </SignUp>
      </Col>
      <Col sm={4} />
    </Row>
  </div>
)

export default All



// WEBPACK FOOTER //
// ./src/account/integrations/All.js